import { fetchPostNoAction } from '@/utils/request'

// 门店列表
export function getShopList(params = {}) {
  return fetchPostNoAction('/getShopList', params)
}
// 门店详情
export function shopInfo(params = {}) {
  return fetchPostNoAction('/shopInfo', params)
}
